import { resignAdminship } from 'admin/actions/OrgRoleActions';
import AffiliationShape, { isAdmin } from 'shapes/Affiliation';
import Checkbox from 'components/Checkbox.jsx';
import CurrentUser from 'auth/CurrentUser';
import cx from 'classnames';
import ConfirmDialog from 'components/ConfirmDialog.jsx';
import { FormattedMessage } from 'react-intl';
import Group from 'entities/Group';
import GroupActions from 'groups/actions/GroupActions';
import GroupAvatar from 'groups/components/GroupAvatar.jsx';
import GroupName from 'groups/components/GroupName.jsx';
import HumanArray from 'components/HumanArray.jsx';
import Organization from 'entities/Organization';
import React from 'react';
import UserActions from 'user/UserActions';

import styles from './styles/SettingsRemoveSchoolModal.css';

const RemoveAction = (props) => {
  return (
    <div
      className={cx(props.className, styles.removeContainer)}
      style={props.style}>
      <Checkbox type="checkbox" checked={props.checked} onChange={props.onCheck} />
      <div>
        {props.children}
      </div>
    </div>
  );
};

RemoveAction.propTypes = {
  onCheck: React.PropTypes.func.isRequired,
};

const SettingsRemoveSchoolModal = React.createClass({
  propTypes: {
    school: React.PropTypes.instanceOf(Organization).isRequired,
    affiliation: AffiliationShape.isRequired,
    ownedGroups: React.PropTypes.arrayOf(React.PropTypes.instanceOf(Group)).isRequired,
    subscribedGroups: React.PropTypes.arrayOf(React.PropTypes.instanceOf(Group)).isRequired,
    onConfirm: React.PropTypes.func,
  },

  getInitialState() {
    return {
      ...this.getNeeds(this.props, {}),
      subscribedGroupsChecked: {},
    };
  },

  componentWillReceiveProps(nextProps) {
    this.setState({ ...this.state, ...this.getNeeds(nextProps, this.props) });
  },

  getNeeds(props, prevProps) {
    // We don't want a change in props to remove your need to have done something
    return {
      needsAdmin: this.isAdmin(prevProps) || this.isAdmin(props),
      needsOwnedGroups: this.isGroupOwner(prevProps) || this.isGroupOwner(props),
    };
  },

  preConfirmPromises() {
    const promises = [];
    if (this.isAdmin()) {
      promises.push(resignAdminship(this.props.school.id, CurrentUser.getUserId()));
    }

    if (this.isGroupOwner()) {
      this.props.ownedGroups.forEach(g => {
        // Don't show the toast when patching the group
        promises.push(GroupActions.patch(g, { organization_id: null }, null, false));
      });
    }

    if (this.isGroupSubscriber()) {
      this.props.subscribedGroups.forEach(g => promises.push(GroupActions.unsubscribeFromGroup(g)));
    }
    return Promise.all(promises).then(() => {
      return UserActions.leaveOrg(this.props.school.id);
    });
  },

  isAdmin(props = this.props) {
    return !!props.affiliation && isAdmin(props.affiliation);
  },

  isGroupOwner(props = this.props) {
    return !!props.ownedGroups && !!props.ownedGroups.length;
  },

  isGroupSubscriber(props = this.props) {
    return !!props.subscribedGroups && !!props.subscribedGroups.length;
  },

  isUnblocked(props = this.props) {
    return !this.isAdmin(props) && !this.isGroupSubscriber(props) && !this.isGroupOwner(props);
  },

  renderAdmin() {
    return (
      <RemoveAction
        className="RemoveAction-admin"
        onCheck={() => this.setState({ needsAdmin: !this.state.needsAdmin })}
        checked={!this.state.needsAdmin}>
        <div className={styles.actionLabel}>
          Remove yourself as administrator.
        </div>
        <div className={styles.actionText}>
          Once you do, you won’t have access to your school’s staff list, staff messaging,
          {' '}and other features for verified administrators.
        </div>
      </RemoveAction>
    );
  },

  renderOwnedGroups() {
    return (
      <RemoveAction
        className="RemoveAction-unlinkGroups"
        onCheck={() => this.setState({ needsOwnedGroups: !this.state.needsOwnedGroups })}
        checked={!this.state.needsOwnedGroups}>
        <div className={styles.actionLabel}>
          Disconnect your classes.
        </div>
        <div className={cx('description', styles.actionText)}>
          <FormattedMessage
            className="description"
            id="settings.removeSchool"
            defaultMessage="The {ownedGroupsCount, plural, one {# class} other {# classes}} you own won’t appear when members of {schoolName} search for classes. They’ll be labeled “not affiliated” unless you join a new school."
            values={{
              ownedGroupsCount: this.props.ownedGroups.length,
              schoolName: this.props.school.getName(),
            }}
          />
        </div>
      </RemoveAction>
    );
  },

  renderSubscribedGroups() {
    const onGroupCheck = (groupId) => {
      const subscribedGroupsChecked = {
        ...this.state.subscribedGroupsChecked,
        [groupId]: !this.state.subscribedGroupsChecked[groupId],
      };
      this.setState({ subscribedGroupsChecked });
    };

    return (
      <div>
        <div className={styles.subscriptionHeader}>
          <div className={styles.actionLabel}>
            {`Leave classes at ${this.props.school.getName()}`}
          </div>
          <div className={cx('description', styles.actionText)}>
            Classes affiliated with a school can only include participants from that school.
          </div>
        </div>
        {this.props.subscribedGroups.map(group => {
          const ownerNames = group.getOwners().map(o => o.getUser().getName());
          return (
            <RemoveAction
              key={group.id}
              style={{ alignItems: 'center', margin: '12px 0', paddingBottom: '12px' }}
              className={cx(`RemoveAction-leave-${group.id}`, styles.leaveGroupAction)}
              onCheck={onGroupCheck.bind(this, group.id)}
              checked={this.state.subscribedGroupsChecked[group.id] || false}>
              <div className={styles.subscription}>
                <GroupAvatar
                  group={group}
                  size="small"
                />
                <div className={styles.subscriptionName}>
                  <GroupName group={group} />
                  <div className={styles.leaveGroupNames}>
                    <HumanArray sample={ownerNames} total={ownerNames.length} />
                  </div>
                </div>
              </div>
            </RemoveAction>
          );
        })}
      </div>
    );
  },

  renderTitle() {
    return (
      <span>
        {`Leave ${this.props.school.getName()}?`}
      </span>
    );
  },

  renderSubtext() {
    if (this.isUnblocked()) {
      return (
        <span>
          {`Once you do, you won’t be affiliated with ${this.props.school.getName()}.`}
        </span>
      );
    } else {
      return (
        <span>
          {'To leave this school, take a minute to complete this checklist'}
        </span>
      );
    }
  },

  render() {
    const { needsAdmin, needsOwnedGroups, subscribedGroupsChecked } = this.state;
    const needsSubscribedGroups =
      this.props.subscribedGroups.some(g => !subscribedGroupsChecked[g.id]);
    return (
      <ConfirmDialog
        eventScreenName="SettingsRemoveSchoolModal"
        {...this.props}
        size="small"
        title={this.renderTitle()}
        subtext={this.renderSubtext()}
        hideCancel
        actionButtonText="Leave"
        preConfirmPromise={this.preConfirmPromises}
        divided
        onConfirm={this.props.onConfirm}
        confirmDisabled={needsAdmin || needsOwnedGroups || needsSubscribedGroups}>
        {this.isAdmin() && this.renderAdmin()}
        {this.isGroupOwner() && this.renderOwnedGroups()}
        {this.isGroupSubscriber() && this.renderSubscribedGroups()}
      </ConfirmDialog>
    );
  },
});

export default SettingsRemoveSchoolModal;



// WEBPACK FOOTER //
// ./src/settings/components/SettingsRemoveSchoolModal.jsx